import { render, staticRenderFns } from "./add.vue?vue&type=template&id=fd9acd0a&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd9acd0a')) {
      api.createRecord('fd9acd0a', component.options)
    } else {
      api.reload('fd9acd0a', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=fd9acd0a&", function () {
      api.rerender('fd9acd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/venueBasicManage/houseKeeper/add.vue"
export default component.exports